import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import "./product-content.component.scoped.scss";
import { useTranslation } from "react-i18next";

import { ProductsService } from "../../../../services/products.services";
import { CommonService } from "../../../../services/common/common.service";
import { GlobalContext } from "../../../../store";
import { Box, Typography } from "@material-ui/core";
import ProductDetailsComponent from "./components/product-details/product-details.component";
import ProductUseCasesComponent from "./components/product-useCases/product-useCases.component";
import ProductHeadComponent from "./components/product-head/product-head.component";
import ProductStaticsComponent from "./components/product-statics/product-statics.component";
import { Skeleton } from "@material-ui/lab";

const ProductTabs = [
  {
    key: "DETAILS",
    label: "PRODUCTS_PAGE.DETAILS",
    component: ProductDetailsComponent,
  },
  {
    key: "RELATED_USE_CASES",
    label: "PRODUCTS_PAGE.RELATED_USE_CASES",
    component: ProductUseCasesComponent,
  },
];

const ProductContentComponent = ({ productId }: { productId: string }) => {
  const { t } = useTranslation();
  const productsService = useMemo(() => new ProductsService(), []);
  const commonService = useMemo(() => new CommonService(), []);
  const { setPageTitle } = useContext(GlobalContext);

  const [product, setProduct] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState<string>("DETAILS");

  const fetchProductDetails = useCallback(async () => {
    try {
      setLoading(true);
      const product = await productsService.get(productId);
      commonService.setTitle(
        `${t("PAGE_META_TITLES.AI_SOFTWARE_PRODUCTS")} - ${product?.name}`,
      );
      setPageTitle(
        t("PAGE_META_TITLES.AI_SOFTWARE_PRODUCTS") + " > " + product?.name,
      );
      setProduct(product);
    } catch (error) {
      console.error("Error fetching course details:", error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, productsService]);

  useEffect(() => {
    fetchProductDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  return (
    <Box className="product__content py-5">
      {/* Product Head */}
      <ProductHeadComponent loading={loading} product={product} />
      {/* Product Statics */}
      <ProductStaticsComponent loading={loading} product={product} />
      {/* Product Tabs */}
      <Box className="product__details__tabs">
        {ProductTabs.map((tab) =>
          loading ? (
            <Skeleton key={tab.key} variant="text" height={25} width={100} />
          ) : (
            <Box
              key={tab.key}
              className={`product__details__tabs__item ${
                activeTab === tab.key ? "active" : ""
              }`}
              onClick={() => setActiveTab(tab.key)}
              style={{ cursor: "pointer" }}
            >
              <Typography variant="h3" className="text-capitalize">
                {t(tab.label)}
              </Typography>
            </Box>
          ),
        )}
      </Box>
      {/* Product Details Content */}
      <Box className="product__details__tabs__content">
        {ProductTabs.map((tab) => {
          if (activeTab !== tab.key) return null;
          const Component = tab.component;
          return (
            <Box key={tab.key} className="product__details__content">
              <Component
                product={product}
                loading={loading}
                onUpdate={fetchProductDetails}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ProductContentComponent;
